<template>
    <div class="d-flex flex-fill full-width flex-column table-report">
        <div class="table-report-label">{{ settings.label || 'Value' }}</div>
        <div
            v-if="settings.drillHistory && settings.drillHistory.length"
            class="m-2"
        >
            <span v-for="(dh, i) in settings.drillHistory" :key="i">
                <a href="javascript:void(0)" @click="changeMap(dh.q, i)">{{
                    dh.title
                }}</a>
                <span
                    v-if="i != settings.drillHistory.length - 1"
                    class="ml-2 mr-2"
                >
                    >
                </span>
            </span>
        </div>
        <div v-if="error" class="ma-8">
            <div class="mb-2 text-center">
                {{ settings.label }} report can't be displayed due to the volume of data.
            </div>
        </div>
        <div v-else-if="settings.chart">
            <highcharts
                class="d-flex justitfy-center full-width"
                :options="cleanSettings.chart"
            />
        </div>
        <div v-else-if="settings.map">
            <highcharts
                :constructor-type="'mapChart'"
                :options="cleanSettings.map"
            ></highcharts>
        </div>
    </div>
</template>

<script>

import * as _ from 'lodash';

export default {
    name: 'ChartReport',
    components: {},
    props: {
        error: {
            type: [Boolean, String],
            default: false
        },
        partner: {
            type: Object,
            required: true
        },
        settings: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            tableSettings: {}
        }
    },
	computed: {
		cleanSettings: function() {
			/*
				We need to use lodash to do the deep cloning as the settings object has functions
				inside and JSON.stringify does not handle functions (i.e. the render function)
			*/
			const settingsCopy = _.cloneDeep(this.settings);
			if (settingsCopy.chart && settingsCopy.chart.series) {
				settingsCopy.chart.series.forEach(series => {
					if (series.data) {
						series.data.forEach(data => {
							if (typeof data.name === 'string') {
								data.name = this.escapeHtml(data.name);  
							}
						});
					}
				});
			}
			return settingsCopy;
		}	
	},
    methods: {
        changeMap(query, index) {
            this.$emit('change-map', { query, index })
        },
		escapeHtml(text) {
			var map = {
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#039;'
			};

			return text.replace(/[&<>"']/g, function(m) { return map[m]; });
		}
    }
}
</script>

<style lang="scss" scoped>
.v-application--wrap {
    min-height: 450px !important; /* overwrite 100vh */
}

.table-report {
    background-color: white;
    min-height: 450px;
    border: 1px solid #ddd;
    margin: 8px;
    padding: 10px;
}

.map {
    min-height: 500px;
}
</style>
